// extracted by mini-css-extract-plugin
export default {"snow":"Snow_snow__JQipc","sliderContainer":"Snow_sliderContainer__0T6ZR","slider":"Snow_slider__GDaAj","sliderValue":"Snow_sliderValue__5u2pZ"};